import styled from "@emotion/styled";
export const StyledTemplateOverviewContent = styled.div`
  .template-benefits-wrapper {
    margin-top: 64px;
    max-width: 632px;
  }

  .template-long-description-wrapper {
    .template-long-description-divider {
      margin: 42px 0;
      border: 0;
      border-top: 2px solid #a2bbc155;
      width: 100%;
    }
  }
`;
